import React, { useContext } from "react";
import { AuthContext, AuthProvider } from "./AuthContext";
import TicketScanner from "./TicketScanner";
import Login from "./Login";

const App = () => {
  const { user } = useContext(AuthContext);

  return user ? <TicketScanner /> : <Login />;
};

const RootApp = () => (
  <AuthProvider>
    <App />
  </AuthProvider>
);

export default RootApp;
